import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";

import HomePageOne from "./pages/HomePageOne";
import CatalogViewPage from "./pages/CatalogViewPage";
import AdminLoginPage from "./pages/Admin/AdminLoginPage";
import CatalogListView from "./pages/Admin/CatalogListView";
import ProductListView from "./pages/Admin/ProductListView";
import ProductDetailView from "./pages/Admin/ProductDetailView";
import ProductFormView from "./pages/Admin/ProductFormView";
import AdminProfilePage from "./pages/Admin/AdminProfilePage";
import AdminOrdersPage from "./pages/Admin/AdminOrdersPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import TermsPage from "./pages/TermsPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        {/* Public Routes */}
        <Route exact path='/' element={<HomePageOne />} />
        <Route exact path='/demo' element={<Navigate to="/u/qZrIlQtIqJXXiYLIOstVxzcG6wM2/c/GtX1GHhEi5" replace />} />
        <Route exact path='/c/:userID/:catalogID' element={<CatalogViewPage />} />
        <Route exact path='/u/:userID/c/:catalogID' element={<CatalogViewPage />} />
        <Route exact path='/deleteAccount' element={<DeleteAccountPage />} />
        <Route exact path='/terms' element={<TermsPage />} />
        <Route exact path='/terms/:locale' element={<TermsPage />} />
        <Route exact path='/terms_conditions' element={<TermsPage />} />
        <Route exact path='/terms_conditions/:locale' element={<TermsPage />} />
        <Route exact path='/Terms_Conditions' element={<TermsPage />} />
        <Route exact path='/Terms_Conditions/:locale' element={<TermsPage />} />

        {/* Auth Routes */}
        <Route exact path='/admin/login' element={<AdminLoginPage />} />

        {/* Protected Vendor Admin Routes */}
        <Route exact path='/admin/dashboard' element={
          <ProtectedRoute>
            <CatalogListView />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/dashboard/:catalogID' element={
          <ProtectedRoute>
            <ProductListView />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/dashboard/:catalogID/new' element={
          <ProtectedRoute>
            <ProductFormView />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/dashboard/:catalogID/:productID' element={
          <ProtectedRoute>
            <ProductDetailView />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/dashboard/:catalogID/:productID/edit' element={
          <ProtectedRoute>
            <ProductFormView />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/profile' element={
          <ProtectedRoute>
            <AdminProfilePage />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/orders' element={
          <ProtectedRoute>
            <AdminOrdersPage />
          </ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
